import { Text } from '@sede-enterprise/shell-ds-react-framework'
import React from 'react'
import './CustomPieLegend.css'

const CustomPieLegend = ({ greenText, amberText, redText }) => {
    return (
        <div className='pie-legend-container'>
            <div className='pie-legend-item'>
                <div className='pie-legend-color green'></div>
                <div className='pie-legend-text'>
                    <Text size='small'>{greenText}</Text>
                </div>
            </div>
            <div className='pie-legend-item'>
                <div className='pie-legend-color amber'></div>
                <div className='pie-legend-text'>
                    <Text size='small'>{amberText}</Text>
                </div>
            </div>
            <div className='pie-legend-item'>
                <div className='pie-legend-color red'></div>
                <div className='pie-legend-text'>
                    <Text size='small'>{redText}</Text>
                </div>
            </div>
        </div>
    )
}

export default CustomPieLegend